import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

/** Màn "Việc cần xem": người nhận bản tin AI 22 giờ (QĐ 0428). */
export function canReadAiBriefing(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.AiBriefingReadOwn);
}

export function canHandleAiBriefing(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.AiBriefingHandle);
}

/** Thẻ "Theo người nhận": CEO xem ai bỏ qua cảnh báo (câu 6a). */
export function canOverseeAiBriefing(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.AiBriefingOversee);
}
